export const Allroutes = {
  login: "/init",
  todos: "/user/todos",
  favorites: "/user/todos/favorites",
  any: "*",
};
